import { render, staticRenderFns } from "./ButtonFile.vue?vue&type=template&id=492f4c01&scoped=true&"
import script from "./ButtonFile.vue?vue&type=script&lang=js&"
export * from "./ButtonFile.vue?vue&type=script&lang=js&"
import style0 from "./ButtonFile.vue?vue&type=style&index=0&id=492f4c01&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492f4c01",
  null
  
)

export default component.exports